<template lang="html">
	<div class="upload_wrap">
		<el-upload class="avatar-uploader" v-if="imagePath(obj_data,columns,name_name,2)" action="" :show-file-list="false" :http-request="fnUploadRequest" :before-upload="before_upload" >
			<span v-if="value">
				<video v-if="suffix(value)" :src="value" controls="controls" class="avatar"></video>
				<img v-else :src="value" class="avatar"/>
			</span>
			<i v-else class="el-icon-plus avatar-uploader-icon"></i>
		</el-upload>
	</div>
</template>
<script>
import { uploadOSS,deleteOSS } from '@/utils/oss';
// import {matchType} from '@/utils/matchType.js'
export default {
	name: 'upload_image',
	data() {
		return {
			loading:null,
		}
	},
	model: {
		prop: 'value',
		event: 'change'
	},
	props: {
		value: {
			type: String,
			default: ''
		},
		obj_data: {
			type: Object,
			default:()=>{}
		},
		file_name: {
			type: String,
			default: 'image' //file video
		},
		name_name: {
			type: String,
			default: ''
		},
		columns:{
			type: Array,
			default:()=>{}
		}
	},
	methods: {
		// yanzhang(ss){
		// 	var name_length = 0;
		// 	var obj_data = this.obj_data;
		// 	var name = obj_data.no;
		// 	if(obj_data.national1=='国内'){
		// 		name+='-'+obj_data.school_seat_province[0];
		// 		if(obj_data.school_seat_province[0]){
		// 			name_length++;
		// 		}

		// 	}else{
		// 		name+='-'+obj_data.school_seat_province;
		// 		if(obj_data.school_seat_province){
		// 			name_length++
		// 		}
		// 	}
		// 	name+='-'+obj_data.university+'-'+obj_data.name;
		// 	if(obj_data.university){
		// 		name_length++;
		// 	}
		// 	if(obj_data.name){
		// 		name_length++;
		// 	}
		// 	if(this.name_name=='个人高清形象照(上传文件后缀jpg)'){
		// 		name+='-个人高清形象照';
		// 		name_length++;
		// 	}else{
		// 		var name_name_name = '';
		// 		for (let i = 0; i < this.columns.length; i++) {
		// 			if(this.columns[i].name=='作品名称'){
		// 				name_name_name = this.columns[i].value;
		// 				break
		// 			}
		// 		}
		// 		name+='-'+name_name_name
		// 		if(name_name_name){
		// 			name_length++;
		// 		}
		// 	}
		// 	if(ss==1){
		// 		return name
		// 	}else{
		// 		return name_length==4
		// 	}
		// },
		async fnUploadRequest(options){
			try {
				let file = options.file;
				var obj_data = this.obj_data;
				var name = this.imagePath(this.obj_data,this.columns,this.name_name,1);
				var houzhui = file.name.split('.').length>1?file.name.split('.')[1]:'';
				name+='.'+houzhui;
				let res = await uploadOSS(this.file_name+'/'+name,file);
	            this.$emit('callback', res);
				this.$message.success("上传成功！");
				this.loading.close();
			} catch (e) {
				console.log(e);
				this.$message.error('上传失败！');
				this.loading.close();
			}
		},
		before_upload(data){
			var name = ['jpg','JPG','mp4','MP4'];
			if(this.name_name=='个人高清形象照(上传文件后缀jpg)'){
				 name = ['jpg','JPG'];
			}
			var file_name=data.name.split('.')[1];
			if(name.indexOf(file_name)==-1){
				if(this.name_name=='个人高清形象照(上传文件后缀jpg)'){
					this.$message.error('上传文件后缀jpg');
				}else{
					this.$message.error('上传文件后缀jpg/mp4，仅限上传一个图片或视频，多图、多角度、多个视频，请自行拼接上传');
				}
				return false
			}
			this.loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
		},
		suffix(data){
			var name=['mp4','mov','avi'];
			var data_arr = data.split('.');
			var suffix_name =data_arr[data_arr.length-1];
			if(name.indexOf(suffix_name)!=-1){
				return true
			}
			return false
		}
	}
}
</script>
<style lang="css">
.upload_wrap .avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	display: block;
	width: 100px;
	height: 100px;
	line-height: 100px!important;
	font-size: 28px;
	color: #8c939d;
	text-align: center;
}
.upload_wrap .avatar-uploader .el-upload .el-upload__input {
    display: none!important;
}
.upload_wrap .avatar-uploader .el-upload:hover {
	border-color: #409EFF;
}
.upload_wrap .avatar-uploader .el-upload .avatar{
	width: 100%;
	height: 100%;
	object-fit: contain;
}
.upload_wrap .avatar-uploader .avatar-uploader-icon {
	width: 100%;
	height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/order_1_upload.vue